<template>
  <div class="page-content">
    <div class="login-logo">
      <img src="../../assets/images/logo.png" style="width: 50px;">
      <span class="font">2345天气王</span>
    </div>
    <div class="bg">
      <img src="../../assets/images/login-bg.png" style="width: 100%; margin-top: 100px;" alt="">
    </div>
    <div class="login-b">
      <el-card class="box-card">
        <div class="header-login">用户登录</div>
        <el-input placeholder="用户名" v-model="username">
          <template slot="append"><i class="el-icon-user"></i></template>
        </el-input>
        <el-input placeholder="密码" v-model="password" type="password" style="margin-top: 20px;">
          <template slot="append"><i class="el-icon-lock"></i></template>
        </el-input>

        <el-input placeholder="验证码" v-model="code" style="margin-top: 20px;">
          <!-- <template slot="prepend"><i class="el-icon-view"></i></template> -->
          <template slot="append">
            <verify-code :identifyCode="verify_code" @getCode="getCode()" style="position: absolute; right: 0; top: 0;"></verify-code>
          </template>
        </el-input>
        <!-- <el-input placeholder="请输入密码" v-model="password" show-password></el-input> -->
        <el-button type="primary" @click="login" style="width: 100%; margin-top: 20px;">登录</el-button>
      </el-card>
    </div>
    <div class="company-desc">
      <div class="font-d">
        <p>公司信息</p>
        <p>地址：北京市朝阳区启阳路4号院中轻大厦A座19层</p>
        <p>上海二三四五网络科技有限公司</p>
      </div>
      <div class="font-b">
        <p>联系我们</p>
        <p>广告合作：adservice@yidian-inc.com</p>
        <p>加入我们：hr@yidian-inc.com</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  /* global require */
  name: 'login',
  data() {
    return {
      username: '',
      password: '',
      code: '',
      verify_code: ''
    };
  },
  created() {
    if (sessionStorage.getItem('token')) {
      this.$router.push({ path: '/' });
    }
    this.getCode();
  },
  beforeCreate() {
    if (this.$route.query.token) {
      this.$http.post('/trader/login/login', {
        token: this.$route.query.token
      }).then(res => {
        if (res.code === 200) {
          window.location.href = this.$Config.apiUrl;
        } else {
          this.$router.push({ path: '/login' });
        }
      });
    } else {
      this.$router.push({ path: '/login' });
    }
  },
  methods: {
    getCode() {
      const str = '123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKMNOPQRSTUVWXYZ';
      const codes = str.split('');
      const arr = [];
      for (let i = 0; i < 4; i++) { // 从0-61之间取随机数
        const index = Math.floor(Math.random() * (58 - 0 + 1) + 0);
        const char = codes[index];
        arr.push(char);
      }
      this.verify_code = arr.join('');
    },
    login() {
      if (this.username === '') {
        this.$message.error('用户名不能为空');
        return false;
      }
      if (this.password === '') {
        this.$message.error('密码不能为空');
        return false;
      }
      if (this.code === '') {
        this.$message.error('验证码不能为空');
        return false;
      }
      if (this.code.toLowerCase() !== this.verify_code.toLowerCase()) {
        this.$message.error('验证码有误');
        this.getCode();
        return false;
      }
      this.$http.post('/trader/login/doLogin', {
        username: this.username,
        password: this.password
      })
        .then(res => {
          if (res.code === 200) {
            this.$router.push({ path: '/' });
          } else {
            this.$message.error(res.msg);
          }
        });
    }
  },
  components: { VerifyCode: resolve => require(['./Components/VerifyCode.vue'], resolve) }
};
</script>
<style lang="less">
  html, body, #app {
    padding: 0;
    margin: 0;
    font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', '微软雅黑', Arial, sans-serif;
    width: 100%;
    height: 100%;
  }
  .login-logo {
    display: flex;
    align-items: center;
    position: absolute;
    top: 20px;
    left: 200px;
    .font {
      font-weight: bold;
      font-size: 24px;
      display: inline-block;
      color: #666;
      padding-left: 10px;
    }
  }
  .page-content {
    width: 100%;
    height: 100%;
    background-size: 100%;
    background-position-y: 10vh;
    position: relative;
    .login-b {
      width: 380px;
      position: absolute;
      top: 15vh;
      right: 5vh;
    }
    .box-card {
      width: 280px;
      height: 320px;
      margin-top: 30px;
      margin-left: 50px;
      border-radius: 15px;
      .header-login {
        width: 100%;
        height: 60px;
        text-align: center;
        color: #166D9F;
        font-size: 24px;
        font-weight: bold;
      }
    }
  }
  .company-desc {
    display: flex;
    margin-top: 20px;
  }
  .font-d {
    margin-left: 300px;
    color: #b8b8b8;
    font-size: 14px;
    width: 380px;
  }
  .font-b {
    margin-left: 200px;
    color: #b8b8b8;
    font-size: 14px;
  }
  .el-card__body {
    padding: 20px;
  }
  .el-input-group__append {

  }
</style>
